var React = require( 'react' );
var createReactClass = require('create-react-class');
var DropDownList = require('./dropDownList.jsx');

var PeriodPicker = createReactClass({
  render: function(){
    return (
        <DropDownList list={this.props.periods} value={this.props.value} onChange={this.props.onChange} />
    );
  }
});

module.exports = PeriodPicker;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/pickers/periodPicker.jsx